<template>
  <tr>
    <td>
        {{entry.OrdinalNumber}}</td>
    <td>
      <b-button @click="$emit('removeEntry', index)" class="rounded-button" v-if="editable">&times;</b-button>
      <!-- <md-button @click="$emit('removeEntry', index)" class="md-fab md-primary remove" v-if="editable">&times;</md-button> -->
    </td>
    <!-- Deal Name -->
    <td class="text-right" style="min-width: 14em;" >
      <b-form-select v-model="entry.DealName" :options="deals" :disabled="deals.length == 0 || !editable" @change="$emit('dealNameChanged', entry, $event)" class=""/>
    </td>
    <!-- Bond Name -->
    <td class="text-right" style="min-width: 7em">
      <b-form-select v-model="entry.BondName" :options="entry.AvailableBonds"
        :disabled="entry.AvailableBonds == undefined || entry.AvailableBonds.length == 0 || !editable" v-if="entry.DealName && !entry.DealName.startsWith('CIRT')" @change="$emit('portfolioChanged')"/>
    </td>
    <!-- Initial Limit / Balance -->
    <td class="text-right"  style="min-width: 7em">
      <b-form-input
        v-model="entry.OwnedFaceAmt"
        class="calculation-settings-input text-right"
        @change="$emit('portfolioChanged')"
        :formatter="formatUSD"
        lazy-formatter
        :disabled="!editable">
      </b-form-input>
</td>
    <!-- Current Limit / Current Balance -->
     <td class="text-right"  style="min-width: 110px">
      <span>{{entry.CurrentBalance}}</span>
    </td>
    <!-- Collateral / Price -->
    <td class="text-right" style="width:100px;">
      <b-form-input
        v-model="entry.Margin"
        class="calculation-settings-input text-right"
        @change="$emit('portfolioChanged')"
        :disabled="!editable">
      </b-form-input>
    </td>
    <!-- CPR -->
    <td class="text-right" style="width:120px;">
      <calculation-settings-input type="CPR" :model="entry.Cpr" :id="'cprInput_' + index" :vectors="vectors" :isDisabled="!editable || Boolean(entry.scenarioSelected)"
        @CPRVectorChange="(data) => { entry.Cpr = data; $emit('portfolioChanged') }"
      />
    </td>
      <!-- CDR -->
    <td class="text-right" style="width:120px;">
      <calculation-settings-input type="CDR" :model="entry.Cdr" :id="'cdrInput_' + index" :vectors="vectors" :isDisabled="!editable || Boolean(entry.scenarioSelected)"
      @CDRVectorChange="(data) => { entry.Cdr = data; $emit('portfolioChanged') }"
    />
    </td>
      <!-- SEV -->
    <td class="text-right" style="width:120px;">
      <calculation-settings-input type="LossSeverity" :model="entry.LossSeverity" :id="'severityInput_' + index" :vectors="vectors" :isDisabled="!editable || Boolean(entry.scenarioSelected)"
        @LossSeverityVectorChange="(data) => { entry.LossSeverity = data; $emit('portfolioChanged') }"
      />
    </td>
      <!-- DLQ -->
    <td class="text-right" style="width:120px;">
      <calculation-settings-input type="Delinquency" :model="entry.Delinquency" :id="'dlqInput_' + index" :vectors="vectors" :isDisabled="!editable || Boolean(entry.scenarioSelected)"
        @DelinquencyVectorChange="(data) => { entry.Delinquency = data; $emit('portfolioChanged') }"
      />
    </td>
    <!-- Scenario -->
    <td>
        <b-form-select
                v-if="entry.scenarioList"
                v-model="entry.scenarioSelected"
                :options="entry.scenarioList"
                value-field="Id"
                text-field="ScenarioNameWithVendor"
                :disabled="entry.scenarioList.length == 0"
                @change="emitChildChange($event, 'scenarioSelected', index)"
                style="min-width: 100px"
        >
            <template #first>
                <b-form-select-option :value="null">off</b-form-select-option>
            </template>
        </b-form-select>
    </td>
    <!-- Call -->
    <td>
        <input type="checkbox"
                v-model="entry.CleanupCall"
                class="transformed"
                @change="emitChildChange(entry.CleanupCall, 'CleanupCall', index, $event)"
        />
    </td>
    <!-- ROI / Yield -->
    <td class="text-right">
      {{ entry.Yield }}
    </td>
    <!-- Rate On Line / WAL -->
    <td class="text-right">
      {{ entry.RateOnLine }}
    </td>
    <!-- Loss On Line / Write down -->
    <td class="text-right">
      {{ entry.LossOnLine }}
    </td>
    <!--Margin On Line / Spread -->
    <td class="text-right">
      {{ entry.ReturnOnLine }}
    </td>
  </tr>
</template>

<script>
import formatter from '../../utilities/Formatter';
import CalculationSettingsInput from '../dealInformation/CalculationSettingsInput';

export default {
  props: {
    entry: Object,
    index: Number,
    deals: Array,
    vectors: Map,
    editable: Boolean
  },
  data() {
    return {
      // editable: false
    };
  },
  methods: {
    formatUSD: function(val, event) {
      return formatter.formatDollarValue(val);
    },
    emitChildChange(propVal, propName, index) {
      this.$emit('onChildChanged', propVal, propName, index);
    }
  },
  components: {
    CalculationSettingsInput
  },
  watch: {
  }
};
</script>
